import { LoginInput } from '@/model/user/LoginInput';
import Http from '../http';

export const login = function (loginForm: LoginInput) {
  return Http.post('/api/OpenApi/Login', loginForm)
}

//获取公司下系统的菜单
export const getMenuByUserId = async  function () {
    return  Http.get('/api/OpenApi/GetMenuByUserId');
 }